import React, { } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth0 } from '../Auth0/react-auth0-spa';

interface IPrivateRouteProps {
    Component?: React.ComponentType<any>;
    render?: any;
    path: string;
    exact?: boolean;
}
export const PrivateRoute = (p: IPrivateRouteProps) => {

    const { path, exact, Component, render, ...rest } = p;
    const { isAuthenticated } = useAuth0();

    // useEffect(() => {
    //     if (loading || isAuthenticated) {
    //         return;
    //     }
    //     const fn = async () => {
    //         await loginWithRedirect({
    //             appState: { targetUrl: window.location.pathname }
    //         });
    //     };
    //     fn();
    // }, [loading, isAuthenticated, loginWithRedirect, path]);

    const renderMe = props =>
        isAuthenticated === true ? render ? render(props) : <Component {...props} /> : <Redirect to={`/login`} />;

    return <Route path={path} render={renderMe} {...rest} />;

}